<template>
  <div>
    <div class="air__utils__heading">
      <h3>Nuevos Servicios</h3>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <Banners :positions="positions" />
      </div>
    </div>
  </div>
</template>

<script>
import Banners from '@/components/widgets/Banners'

export default {
  components: {
    Banners,
  },
  data () {
    return {
      // Advertisings: [],
      positions: [
        { 'name': 'NEW_SERVICES', 'description': 'Nuevos Servicios' },
      ],
    }
  },
  created() {
    // this.fetchSliderHome()
  },
  methods: {

  },
}
</script>
